import React, { Component } from 'react';

export class Output extends Component {
  render() {
    const { className, styles, select, value, label } = this.props;
    const id = `${select}-output`;
    return (
      <p className={className} style={styles}>
        <label htmlFor={id}>{label}</label>
        <output id={id} name={id}>{value}</output>
      </p>
    );
  }
}

Output.defaultProps = {
  className: null,
  styles: null,
}

export default Output;
